import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Terminals} from "../../../../shared/interface/terminals";
import {ReceivablesTransfer} from "../../../../shared/interface/receivables-transfer";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {TerminalsService} from "../../../../shared/services/terminals.service";
import {ReceivablesTransferService} from "../../../../shared/services/receivables-transfer.service";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {
  DictService,
  RECEIVABLES_IMPORT_ROW_STATUS,
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION,
  RECEIVABLES_IMPORT_ROW_STATUS_NEW, RECEIVABLES_TRANSFER_STATUS,
  RECEIVABLES_TRANSFER_STATUS_COMPLETED,
  RECEIVABLES_TRANSFER_STATUS_SUSPENDED,
  RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED
} from "../../../../shared/services/dict.service";
import {
  ConfirmDialogWithReasonComponent
} from "../../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";

@Component({
  selector: 'app-transfer-details-view',
  templateUrl: './transfer-details-view.component.html',
  styleUrls: ['./transfer-details-view.component.scss']
})
export class TransferDetailsViewComponent implements OnInit, OnDestroy {

  @Input() receivablesTransfer: Observable<ReceivablesTransfer>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() modifyClickedEdit = new EventEmitter<any>();

  receivablesTransferObject?: ReceivablesTransfer;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly RECEIVABLES_TRANSFER_STATUS_COMPLETED = RECEIVABLES_TRANSFER_STATUS_COMPLETED;

  readonly RECEIVABLES_TRANSFER_STATUS_SUSPENDED = RECEIVABLES_TRANSFER_STATUS_SUSPENDED;
  readonly RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED = RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED;

  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private receivablesTransferService: ReceivablesTransferService,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.receivablesTransfer
      .pipe(takeUntil(this.destroyed$))
      .subscribe((receivablesTransfer: ReceivablesTransfer) => {
        this.receivablesTransferObject = receivablesTransfer;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć przelew?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesTransferService.delete(this.receivablesTransferObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto przelew', '', {duration: 2000});
            this.router.navigate(['/naleznosci/przelewy']);
          });
      }
    });
  }

  modify(): void {
    this.modifyClickedEdit.emit();
  }

  toBeCompledRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Do zrealizowania?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED, RECEIVABLES_TRANSFER_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesTransferService.updateStatus(
              this.receivablesTransferObject.uuid,
              dictId
            )
              .subscribe(() => {
                this.modifyClicked.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }

  suspendedRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogWithReasonComponent, {
      width: '500px',
      data: {text: 'Podaj powód wstrzymania płatności?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.accepted) {
        this.dictService.getId(RECEIVABLES_TRANSFER_STATUS_SUSPENDED, RECEIVABLES_TRANSFER_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesTransferService.updateStatus(
              this.receivablesTransferObject.uuid,
              dictId,
              result.reason,
            )
              .subscribe(() => {
                this.modifyClicked.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }
}
